import { render } from "./ManualQRCode.vue?vue&type=template&id=23b8357e"
import script from "./ManualQRCode.vue?vue&type=script&lang=js"
export * from "./ManualQRCode.vue?vue&type=script&lang=js"

import "./ManualQRCode.vue?vue&type=style&index=0&id=23b8357e&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__